module.exports = __webpack_public_path__ + "assets/images/6eed88ed9757663c90bc4c0d2c2df068.svg";